export const SHOW_ACCOUNT_LINK_REMINDER = 'accountLinkReminder/SHOW_ACCOUNT_LINK_REMINDER';
export const HIDE_ACCOUNT_LINK_REMINDER = 'accountLinkReminder/HIDE_ACCOUNT_LINK_REMINDER';
